module.exports = __webpack_public_path__ + "static/media/default-upload.45295a5e.jpg";